/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  function unStick(el, delimiter) {
    var height = $(el).height() + 20;
    var fired = false;
    $(window).scroll(function() {
      var s = $(delimiter).offset().top - $(window).scrollTop();
      if ( s < height ) {
        $(el).unstick();
        fired = false;
      } else {
        if( !$(el).hasClass( "is-sticky") && !fired ) {
          $(el).sticky({topSpacing:20});
          fired = true;
        }
      }
    });
  }

  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var GlobalCleveland = {
    // All pages
    'common': {
      init: function() {

        function intlNewcomerMenu() {
          $('.menu-for-international-newcomers > ul.sub-menu').css('width',$('.menu-for-international-newcomers').width());
        }

        /*
        function getParameterByName(name, url) {
            if (!url) {
              url = window.location.href;
            }
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        }
        */

        // on document load
        $( document ).ready(function() {

          /*
          if (Cookies.get('gcHidePopup')) {
            $hideModal = Cookies.get('gcHidePopup');
          } else {
            $hideModal = 0;
          }
          if ( !$hideModal ) {
            setTimeout( function(){
              $("#newsletterModal").modal();

              $("#newsletterModal .modal-dialog").css({
                "margin-top": function() {
                  return window.innerHeight / 4;
                }
              });

              $('#newsletterModal').on('hidden.bs.modal', function (e) {
                Cookies.set('gcHidePopup', '1');
              });

            }  , 5000 );
          }
          */

          // intl newcomer menu resize
          intlNewcomerMenu();

          // Mobile menu toggle stuffs
          $('#menu-primary-menu > li.menu-item-has-children > a').click(function(e){
            e.preventDefault();
            $(this).parent().toggleClass('open');
          });

          $('#toggleIcon').click(function(){
            $(this).toggleClass('open');
            if ( $(this).hasClass('open') ) {
              $('#menu').slideDown('slow');
              $('.top-navbar').addClass('open');
            } else {
              $('#menu').slideUp('slow');
              $('.top-navbar').removeClass('open');
            }
          });
          // If resized
          $(window).resize(function(){
            intlNewcomerMenu();
            if ( $(window).width() > 768 ) {
              $('#menu').show();
            } else {
              if ( $('.top-navbar').hasClass('open') ) {
                $('.top-navbar').removeClass('open');
              } else {
                $('#menu').hide();
              }
            }
          });

          // Funders Slider
          $('#funders-list-slider').unslider({
            //animation: 'vertical',
            arrows: false,
            autoplay: true,
            delay:10000,
            infinite: true
          });

          // Funders Slider
          $('#ihySlider').unslider({
            //animation: 'vertical',
            arrows: {
              prev: '<a class="unslider-arrow prev"></a>',
	            next: '<a class="unslider-arrow next"></a>'
            },
            autoplay: false,
            delay:10000,
            infinite: true
          });

        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
      }
    },
    // Home page
    'home': {
      init: function() {
        // JavaScript to be fired on the home page
      },
      finalize: function() {
      }
    },
    'career_resources': {
      init: function() {
        $( document ).ready(function() {

          $("#js-menu").sticky({topSpacing:20});
          unStick('#js-menu','.funders-block');
          $('body').scrollspy({ target: '#js-menu' });

        });


      }
    },
    'international_newcomers': {
      init: function() {
        $( document ).ready(function() {

          $("#in-widget").sticky({topSpacing:20});
          unStick('#in-widget','.funders-block');
          $('body').scrollspy({ target: '#in-widget' });

        });
      }
    },
    'volunteering': {
      init: function () {
        $( document ).ready(function() {

          $("#volunteer-widget").sticky({topSpacing:20});
          unStick('#volunteer-widget','.funders-block');
          $('body').scrollspy({ target: '#volunteer-widget' });

        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = GlobalCleveland;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.replace(/-/g, '_').split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
